import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    unitPriceInUsd: 0,
    walletinfo: {

    }
  },
  getters: {
    getUnitPriceInUsd (state) {
      return state.unitPriceInUsd
    },
    getCartItemAmount (state) {
      return state.rows.length
    },
    isInCart: (state) => (relModel, relId) => {
      const a = state.rows.find(item => item.shopping_cart_rel_model === relModel &&
        item.shopping_cart_rel_id === relId
      )
      return !!a
    }
  },

  mutations: {
    SET_UNIT_PRICE_IN_USD (state, payload) {
      state.unitPriceInUsd = payload
    }
  },

  actions: {
    init: ({ commit }) => {
      return ApiUtils.postData({
        data: [{ api: 'M1902CoinsTypeCurrencyService.GetACoinCurrency' }]
      }).then(data => {
        commit('SET_UNIT_PRICE_IN_USD', data[0].output.find(currency => currency.code === 'USD').coins_type_currency_unit_price)
      })
    },
    read: ({ commit }) => {
      return ApiUtils.postData({
        data: [{ api: 'M2701ShoppingCartService.read' }]
      }).then(data => {
        commit('SET_ROWS', data[0].output)
      })
    },
    doDelete: ({ commit }, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'M2701ShoppingCartService.doDelete', input: payload }]
      }).then(data => {
        commit('SET_ROWS', data[0].output)
      })
    },
    checkout: ({ state }, salesOrderAmount) => {
      return ApiUtils.postData({
        data: [{
          api: 'M2701ShoppingCartService.checkout',
          input: { ...salesOrderAmount, shopping_cart: state.rows }
        }]
      })
    },
    doAdd: ({ commit }, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'M2701ShoppingCartService.doAdd', input: payload }]
      }).then(data => {
        commit('SET_ROWS', data[0].output)
      })
    },
    initWallet: ({ commit, state }) => {
      ApiUtils.postData({
        data: [{ api: 'M2001CoinsService.initWallet' }]
      }).then(data => {
        state.walletinfo = data[0].output
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
